import "./createYacht.css";
import { useState, useEffect } from "react";
import { PlaceOutlined } from "@material-ui/icons";
import Moment from "moment";
// import Moment from "Utills/Model/CustomModel";
import { Link } from "react-router-dom";
import { ClickAwayListener } from "@material-ui/core";
import { Fade } from "react-reveal";
import { DateRangePicker } from "react-date-range";
//
import fbIcon from "assets/Images/icons/facebook.svg";
import instaIcon from "assets/Images/icons/insta.svg";
// icons
import icon1 from "assets/Images/icons/extras/icon1.png";
import icon2 from "assets/Images/icons/extras/icon2.png";
import icon3 from "assets/Images/icons/extras/icon3.png";
import icon4 from "assets/Images/icons/extras/icon4.png";
import icon5 from "assets/Images/icons/extras/icon5.png";
import icon6 from "assets/Images/icons/extras/icon6.png";
import icon7 from "assets/Images/icons/extras/icon7.png";
import icon8 from "assets/Images/icons/extras/icon8.png";
import icon9 from "assets/Images/icons/extras/icon9.png";
// step4
import Listing from "../Listing";
import { Helmet } from "react-helmet";

const CreateYacht = () => {
  const [activeStep, setActiveStep] = useState(0);

  // form data state
  const [formData, setFormData] = useState({
    boatType: "",
    place: "",
    guests: 1,
    skipper: true,
  });
  const [errors, setErrors] = useState({ place: { invalid: false, msg: "" } });
  const [calendarMode, setCalendarMode] = useState("start");

  const [dates, setDates] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
      selected: false,
    },
  ]);

  const [locationModal, setLocationModal] = useState(false);
  const [boatTypeModal, setBoatTypeModal] = useState(false);
  const [dateSelected, setDateSelected] = useState(false);
  // =============================== features List ==================
  const [featuresList, setFeaturesList] = useState({
    bbq_catering: false,
    events_allowed: false,
    events_allowed1: false,
    fishing_equipment: false,
    music_system: false,
    open_bar: false,
    pets_allowed: false,
    watersports: false,
    wifi: false,
  });
  //
  const steps = [
    <Step1
      formData={formData}
      errors={errors}
      setErrors={setErrors}
      setLocationModal={setLocationModal}
      locationModal={locationModal}
      setFormData={setFormData}
      steps={4}
      activeStep={activeStep}
      setActiveStep={setActiveStep}
    />,
    <Step2
      formData={formData}
      errors={errors}
      setErrors={setErrors}
      setBoatTypeModal={setBoatTypeModal}
      boatTypeModal={boatTypeModal}
      setFormData={setFormData}
      steps={4}
      activeStep={activeStep}
      setActiveStep={setActiveStep}
    />,
    <Step3
      formData={formData}
      errors={errors}
      setErrors={setErrors}
      setLocationModal={setLocationModal}
      locationModal={locationModal}
      setFormData={setFormData}
      steps={4}
      activeStep={activeStep}
      setActiveStep={setActiveStep}
      calendarMode={calendarMode}
      setCalendarMode={setCalendarMode}
      dates={dates}
      setDates={setDates}
      dateSelected={dateSelected}
      setDateSelected={setDateSelected}
    />,

    <Step4
      formData={formData}
      errors={errors}
      setErrors={setErrors}
      setBoatTypeModal={setBoatTypeModal}
      boatTypeModal={boatTypeModal}
      setFormData={setFormData}
      steps={4}
      activeStep={activeStep}
      setActiveStep={setActiveStep}
      featuresList={featuresList}
      setFeaturesList={setFeaturesList}
    />,
    // <Step4
    //   formData={formData}
    //   errors={errors}
    //   setErrors={setErrors}
    //   setBoatTypeModal={setBoatTypeModal}
    //   boatTypeModal={boatTypeModal}
    //   setFormData={setFormData}
    //   steps={4}
    //   activeStep={activeStep}
    //   setActiveStep={setActiveStep}
    //   featuresList={featuresList}
    //   setFeaturesList={setFeaturesList}
    // />,
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeStep]);
  // console.log(activeStep);

  return <main>
     <Helmet>
        <title>Cyan | Book your boat in 4 steps</title>
      </Helmet>
    {steps[activeStep]}</main>;
};

const Step1 = ({
  formData,
  setFormData,
  // errors,
  setLocationModal,
  locationModal,
  setErrors,
  steps,
  activeStep,
  setActiveStep,
}) => {
  // static cities for dropdown
  let cities = [
    { name: "Athens", id: 0 },
    { name: "Mykonos", id: 1 },
    { name: "Corfu", id: 2 },
    { name: "Lefkada", id: 3 },
    { name: "Tinos", id: 4 },
  ];
  return (
    <section className="createYacht_sec step_1">
      <div className="createYacht_container">
        <Fade cascade>
          <div className="create_yacht_modal">
            <h2 className="text-center">
              Make your own yachting trip <br /> in 4 steps.
            </h2>
            <p className="my-3 fw-light text-center">
              Let us know more about your trip
            </p>
            <div className="">
              <p className="fw-light text-left pb-2 text-center">
                Choose your departure location
              </p>
              <div className="all-offer-page-top-form">
                <ClickAwayListener onClickAway={() => setLocationModal(false)}>
                  <div className="col-md-11 col-12 p-0">
                    <div className="left-side-choose-city  d-flex align-items-center justify-content-start">
                      <span className="text-sec">
                        <PlaceOutlined />
                      </span>
                      <div
                        onClick={() => setLocationModal(!locationModal)}
                        className={`select_departure_location d-flex justify-content-start align-items-center ${
                          locationModal ? "openedLocationModal" : ""
                        }`}
                      >
                        <span>
                          {formData?.place?.length > 0
                            ? formData?.place
                            : "Departure location"}
                        </span>
                        <svg
                          width="15"
                          height="8"
                          viewBox="0 0 15 8"
                          fill="none"
                        >
                          <path
                            d="M0.612998 0.206748C0.863602 -0.0438557 1.25576 -0.0666378 1.5321 0.138402L1.61127 0.206748L7.70037 6.29553L13.7895 0.206748C14.0401 -0.0438557 14.4322 -0.0666378 14.7086 0.138402L14.7877 0.206748C15.0383 0.457352 15.0611 0.849506 14.8561 1.12585L14.7877 1.20502L8.1995 7.79325C7.9489 8.04386 7.55674 8.06664 7.2804 7.8616L7.20123 7.79325L0.612998 1.20502C0.337334 0.929352 0.337334 0.482412 0.612998 0.206748Z"
                            fill="#1A4D6D"
                          />
                        </svg>
                      </div>
                      <div
                        className={`select_departure_location_modal ${
                          locationModal ? "openedLocationModal" : ""
                        }`}
                      >
                        <h5>Greece</h5>
                        {cities?.map((v, i) => (
                          <p
                            key={i}
                            className=""
                            onClick={() => {
                              setFormData({
                                ...formData,
                                place: cities[v?.id]?.name,
                              });
                              setErrors({
                                place: { invalid: false, msg: "" },
                              });
                              setLocationModal(false);
                            }}
                          >
                            {v?.name}
                          </p>
                        ))}
                      </div>
                    </div>
                  </div>
                </ClickAwayListener>
              </div>
              <p className="fw-light text-left mt-3 pb-2">
                Choose the number of guests
              </p>
              <div className="create_yacht_guests user-select-none">
                <svg width="19" height="16" viewBox="0 0 19 16" fill="none">
                  <path
                    d="M9.45598 10.5232C12.4193 10.5232 14.9495 11.0663 14.9495 13.2397C14.9495 15.4122 12.4355 15.9751 9.45598 15.9751C6.49269 15.9751 3.96244 15.432 3.96244 13.2595C3.96244 11.0861 6.47645 10.5232 9.45598 10.5232ZM14.1939 9.21451C15.3268 9.19024 16.5448 9.37008 16.9948 9.49776C17.9483 9.71447 18.5755 10.1569 18.8353 10.7998C19.0549 11.3276 19.0549 11.94 18.8353 12.4669C18.4378 13.4642 17.1564 13.7843 16.6584 13.867C16.5556 13.885 16.4728 13.7816 16.4837 13.662C16.7381 10.8987 14.7144 9.58858 14.1908 9.28735C14.1684 9.27386 14.1638 9.25318 14.1661 9.24059C14.1676 9.2316 14.1769 9.21721 14.1939 9.21451ZM4.59332 9.21265L4.80665 9.21487C4.82367 9.21757 4.83217 9.23196 4.83372 9.24005C4.83604 9.25354 4.8314 9.27332 4.80975 9.28771C4.28545 9.58894 2.26172 10.8991 2.51613 13.6614C2.52696 13.7819 2.44499 13.8844 2.34214 13.8674C1.84413 13.7846 0.562771 13.4645 0.165293 12.4673C-0.0550978 11.9395 -0.0550978 11.328 0.165293 10.8002C0.425123 10.1572 1.0515 9.71483 2.00498 9.49722C2.45582 9.37044 3.67299 9.1906 4.80665 9.21487L4.59332 9.21265ZM9.45598 0C11.4735 0 13.0913 1.87934 13.0913 4.22626C13.0913 6.57229 11.4735 8.45343 9.45598 8.45343C7.43843 8.45343 5.82069 6.57229 5.82069 4.22626C5.82069 1.87934 7.43843 0 9.45598 0ZM14.3911 0.704797C16.3398 0.704797 17.8702 2.83681 17.349 5.21161C16.9971 6.8104 15.7235 7.87236 14.3045 7.8292C14.1622 7.8247 14.0223 7.80942 13.8869 7.78244C13.7887 7.76266 13.7392 7.63407 13.7949 7.53876C14.3362 6.61257 14.6448 5.49846 14.6448 4.30252C14.6448 3.05442 14.3076 1.89085 13.7222 0.936792C13.7037 0.907118 13.6897 0.861259 13.7083 0.827089C13.7238 0.799213 13.7524 0.784826 13.7794 0.777633C13.9766 0.730874 14.1792 0.704797 14.3911 0.704797ZM4.6083 0.704707C4.82019 0.704707 5.02279 0.730784 5.22076 0.777543C5.24705 0.784736 5.27644 0.800023 5.2919 0.826999C5.30969 0.861169 5.29654 0.907028 5.27798 0.936702C4.69259 1.89076 4.35543 3.05433 4.35543 4.30243C4.35543 5.49837 4.66398 6.61248 5.20529 7.53867C5.26097 7.63398 5.21148 7.76257 5.11327 7.78235C4.97717 7.81023 4.83797 7.82461 4.69568 7.82911C3.27668 7.87227 2.00305 6.81031 1.65119 5.21152C1.12921 2.83672 2.65958 0.704707 4.6083 0.704707Z"
                    fill="#3F8BBF"
                  />
                </svg>
                &nbsp;
                <svg
                  className="cursor-pointer"
                  width="18"
                  height="17"
                  viewBox="0 0 18 17"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.80484 0.469971C4.25093 0.469971 0.559082 4.06496 0.559082 8.49938C0.559082 12.9338 4.25093 16.5288 8.80484 16.5288C13.3588 16.5288 17.0506 12.9338 17.0506 8.49938C17.0506 4.06496 13.3588 0.469971 8.80484 0.469971ZM5.80639 7.76944C5.60758 7.76944 5.41691 7.84634 5.27633 7.98323C5.13575 8.12012 5.05677 8.30579 5.05677 8.49938C5.05677 8.69298 5.13575 8.87864 5.27633 9.01553C5.41691 9.15242 5.60758 9.22933 5.80639 9.22933H11.8033C12.0021 9.22933 12.1928 9.15242 12.3334 9.01553C12.4739 8.87864 12.5529 8.69298 12.5529 8.49938C12.5529 8.30579 12.4739 8.12012 12.3334 7.98323C12.1928 7.84634 12.0021 7.76944 11.8033 7.76944H5.80639Z"
                    onClick={() => {
                      setFormData({
                        ...formData,
                        guests:
                          formData.guests - 1 > 0 ? formData.guests - 1 : 1,
                      });
                    }}
                    fill={formData.guests - 1 > 0 ? "#3F8BBF" : "#212121"}
                  />
                </svg>
                <span className="text-sec">
                  {" "}
                  {formData.guests > 9
                    ? formData.guests
                    : "0" + formData.guests}{" "}
                </span>
                <svg
                  className="cursor-pointer"
                  width="18"
                  height="17"
                  viewBox="0 0 18 17"
                  fill="none"
                  onClick={() => {
                    setFormData({
                      ...formData,
                      guests: formData.guests + 1,
                    });
                  }}
                >
                  <path
                    d="M9.19449 0.469971C4.64092 0.469971 0.94873 4.06528 0.94873 8.49938C0.94873 12.9335 4.64092 16.5288 9.19449 16.5288C13.7481 16.5288 17.4403 12.9335 17.4403 8.49938C17.4403 4.06528 13.7481 0.469971 9.19449 0.469971ZM12.7284 8.92953C12.7284 9.00839 12.6621 9.07291 12.5811 9.07291H9.78348V11.7972C9.78348 11.876 9.71722 11.9406 9.63623 11.9406H8.75276C8.67177 11.9406 8.60551 11.876 8.60551 11.7972V9.07291H5.80784C5.72686 9.07291 5.66059 9.00839 5.66059 8.92953V8.06923C5.66059 7.99037 5.72686 7.92585 5.80784 7.92585H8.60551V5.20159C8.60551 5.12273 8.67177 5.05821 8.75276 5.05821H9.63623C9.71722 5.05821 9.78348 5.12273 9.78348 5.20159V7.92585H12.5811C12.6621 7.92585 12.7284 7.99037 12.7284 8.06923V8.92953Z"
                    fill="#3F8BBF"
                  />
                </svg>
              </div>
              {/* {errors?.place?.invalid && (
                  <h5 className="text-warning">{errors?.place?.msg}</h5>
                )} */}
              {/* btns next/prev */}
              <div className="row justify-content-between my-3">
                <div className="col-md-5 col-6">
                  <button className="light-btn w-100 text-white" disabled>
                    Previous
                  </button>
                </div>
                <div className="col-md-5 col-6">
                  <button
                    onClick={() => setActiveStep(1)}
                    className="light-btn w-100 text-white"
                  >
                    Next
                  </button>
                </div>
              </div>
              {/*  */}
              <p className="my-3 fw-light text-center">
                Experience bespoke yacht voyages across Greece
              </p>
              {/*    */}
              <div className="cs-timeline">
                {[...Array(steps)].map((step, i) => {
                  return (
                    <div
                      key={i}
                      className={`${
                        activeStep >= i ? "bg-sec text-white" : "bg-white"
                      }  create_yacht_cs_step cs-step`}
                    >
                      {i + 1}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Fade>
      </div>
      <Socials />
      {/*  */}
    </section>
  );
};

const Step3 = ({
  formData,
  setFormData,
  errors,
  setLocationModal,
  locationModal,
  setErrors,
  steps,
  activeStep,
  setActiveStep,
  setCalendarMode,
  calendarMode,
  dates,
  setDates,
  dateSelected,
  setDateSelected,
}) => {
  const getDaysLength = () => {
    var start = Moment(dates[0].endDate);
    var end = Moment(dates[0].startDate);
    //Difference in number of days
    let s = Moment.duration(start.diff(end)).asDays() + 1;
    return s;
  };
  return (
    <section className="createYacht_sec step_2">
      <div className="createYacht_container">
        <Fade cascade>
          <div className="create_yacht_modal">
            <h2 className="text-center">Choose the dates for your trip</h2>
            <div className="row mx-0 mt-3 justify-content-between">
              <div
                className={`${
                  dateSelected ? "selected_b " : " "
                } create_yacht_dates_boxes`}
              >
                <svg width="20" height="23" viewBox="0 0 20 23" fill="none">
                  <path
                    d="M13.9146 2.558e-06C14.3816 -0.00112855 14.7509 0.372985 14.752 0.871803L14.7531 1.72206C17.7832 1.96694 19.7848 4.09598 19.788 7.36098L19.8 16.9179C19.8043 20.4776 17.6355 22.6679 14.159 22.6736L5.66708 22.6849C2.21232 22.6894 0.0163055 20.447 0.0119613 16.8771L7.29013e-06 7.4324C-0.00432964 4.14586 1.92669 2.02249 4.95679 1.73567L4.95571 0.885408C4.95462 0.386589 5.31302 0.0113419 5.79089 0.0113419C6.26876 0.0102082 6.62716 0.384322 6.62824 0.88314L6.62933 1.67671L13.0805 1.66765L13.0794 0.874071C13.0784 0.375252 13.4368 0.00113881 13.9146 2.558e-06ZM14.3577 16.0971H14.3469C13.8473 16.1096 13.4465 16.5415 13.4574 17.063C13.4585 17.5845 13.8614 18.0141 14.361 18.0255C14.8704 18.0243 15.2831 17.5924 15.282 17.0596C15.282 16.5268 14.8682 16.0971 14.3577 16.0971ZM5.4086 16.0982C4.90901 16.1209 4.51803 16.5528 4.51911 17.0743C4.54192 17.5958 4.95462 18.0039 5.45421 17.9801C5.94402 17.9575 6.33392 17.5255 6.31111 17.004C6.30025 16.4939 5.89732 16.0971 5.4086 16.0982ZM9.88317 16.0926C9.38358 16.1164 8.99368 16.5472 8.99368 17.0687C9.01649 17.5902 9.42919 17.9971 9.92878 17.9745C10.4175 17.9507 10.8085 17.5199 10.7857 16.9972C10.7748 16.4882 10.3719 16.0914 9.88317 16.0926ZM5.40317 12.017C4.90358 12.0397 4.51368 12.4716 4.51477 12.9931C4.53649 13.5146 4.95028 13.9227 5.44987 13.8989C5.93859 13.8762 6.32849 13.4443 6.30568 12.9228C6.29482 12.4126 5.89298 12.0159 5.40317 12.017ZM9.87882 11.9773C9.37923 12 8.98825 12.4319 8.98933 12.9534C9.01106 13.4749 9.42485 13.8819 9.92444 13.8592C10.4132 13.8354 10.8031 13.4046 10.7813 12.8831C10.7694 12.373 10.3675 11.9762 9.87882 11.9773ZM14.3534 11.983C13.8538 11.9943 13.4628 12.4138 13.4639 12.9353V12.9477C13.4748 13.4692 13.8875 13.8649 14.3881 13.8535C14.8769 13.8411 15.2668 13.4091 15.2559 12.8877C15.2331 12.3888 14.841 11.9818 14.3534 11.983ZM13.0827 3.41351L6.6315 3.42258L6.63259 4.33972C6.63259 4.82834 6.27527 5.21379 5.79741 5.21379C5.31954 5.21492 4.96005 4.83061 4.96005 4.34199L4.95897 3.46906C2.84115 3.68786 1.66929 4.97118 1.67254 7.43013L1.67363 7.7827L18.1166 7.76003V7.36324C18.0699 4.92584 16.8839 3.64705 14.7552 3.45659L14.7563 4.32952C14.7563 4.817 14.3881 5.20359 13.9211 5.20359C13.4433 5.20472 13.0838 4.81927 13.0838 4.33179L13.0827 3.41351Z"
                    fill="#3F8BBF"
                  />
                </svg>
                <span className="text-muted">
                  {dateSelected
                    ? dates[0]?.startDate
                      ? Moment(dates[0].startDate).format("DD-MM-YYYY") ||
                        "Starting date"
                      : "Starting date"
                    : "Starting date"}
                </span>
                <svg width="18" height="10" viewBox="0 0 18 10" fill="none">
                  <path
                    d="M0.255101 0.255101C0.564313 -0.0541122 1.04818 -0.0822225 1.38915 0.17077L1.48683 0.255101L9 7.76787L16.5132 0.255101C16.8224 -0.0541122 17.3062 -0.0822225 17.6472 0.17077L17.7449 0.255101C18.0541 0.564313 18.0822 1.04818 17.8292 1.38915L17.7449 1.48683L9.61587 9.61587C9.30665 9.92508 8.82279 9.95319 8.48182 9.7002L8.38413 9.61587L0.255101 1.48683C-0.0850335 1.1467 -0.0850335 0.595235 0.255101 0.255101Z"
                    fill="#1A4D6D"
                  />
                </svg>
              </div>
              <div
                className={`${
                  dateSelected ? "selected_b " : " "
                } create_yacht_dates_boxes`}
              >
                <svg width="20" height="23" viewBox="0 0 20 23" fill="none">
                  <path
                    d="M13.9146 2.558e-06C14.3816 -0.00112855 14.7509 0.372985 14.752 0.871803L14.7531 1.72206C17.7832 1.96694 19.7848 4.09598 19.788 7.36098L19.8 16.9179C19.8043 20.4776 17.6355 22.6679 14.159 22.6736L5.66708 22.6849C2.21232 22.6894 0.0163055 20.447 0.0119613 16.8771L7.29013e-06 7.4324C-0.00432964 4.14586 1.92669 2.02249 4.95679 1.73567L4.95571 0.885408C4.95462 0.386589 5.31302 0.0113419 5.79089 0.0113419C6.26876 0.0102082 6.62716 0.384322 6.62824 0.88314L6.62933 1.67671L13.0805 1.66765L13.0794 0.874071C13.0784 0.375252 13.4368 0.00113881 13.9146 2.558e-06ZM14.3577 16.0971H14.3469C13.8473 16.1096 13.4465 16.5415 13.4574 17.063C13.4585 17.5845 13.8614 18.0141 14.361 18.0255C14.8704 18.0243 15.2831 17.5924 15.282 17.0596C15.282 16.5268 14.8682 16.0971 14.3577 16.0971ZM5.4086 16.0982C4.90901 16.1209 4.51803 16.5528 4.51911 17.0743C4.54192 17.5958 4.95462 18.0039 5.45421 17.9801C5.94402 17.9575 6.33392 17.5255 6.31111 17.004C6.30025 16.4939 5.89732 16.0971 5.4086 16.0982ZM9.88317 16.0926C9.38358 16.1164 8.99368 16.5472 8.99368 17.0687C9.01649 17.5902 9.42919 17.9971 9.92878 17.9745C10.4175 17.9507 10.8085 17.5199 10.7857 16.9972C10.7748 16.4882 10.3719 16.0914 9.88317 16.0926ZM5.40317 12.017C4.90358 12.0397 4.51368 12.4716 4.51477 12.9931C4.53649 13.5146 4.95028 13.9227 5.44987 13.8989C5.93859 13.8762 6.32849 13.4443 6.30568 12.9228C6.29482 12.4126 5.89298 12.0159 5.40317 12.017ZM9.87882 11.9773C9.37923 12 8.98825 12.4319 8.98933 12.9534C9.01106 13.4749 9.42485 13.8819 9.92444 13.8592C10.4132 13.8354 10.8031 13.4046 10.7813 12.8831C10.7694 12.373 10.3675 11.9762 9.87882 11.9773ZM14.3534 11.983C13.8538 11.9943 13.4628 12.4138 13.4639 12.9353V12.9477C13.4748 13.4692 13.8875 13.8649 14.3881 13.8535C14.8769 13.8411 15.2668 13.4091 15.2559 12.8877C15.2331 12.3888 14.841 11.9818 14.3534 11.983ZM13.0827 3.41351L6.6315 3.42258L6.63259 4.33972C6.63259 4.82834 6.27527 5.21379 5.79741 5.21379C5.31954 5.21492 4.96005 4.83061 4.96005 4.34199L4.95897 3.46906C2.84115 3.68786 1.66929 4.97118 1.67254 7.43013L1.67363 7.7827L18.1166 7.76003V7.36324C18.0699 4.92584 16.8839 3.64705 14.7552 3.45659L14.7563 4.32952C14.7563 4.817 14.3881 5.20359 13.9211 5.20359C13.4433 5.20472 13.0838 4.81927 13.0838 4.33179L13.0827 3.41351Z"
                    fill="#3F8BBF"
                  />
                </svg>
                <span className="text-muted">
                  {dateSelected
                    ? dates[0]?.endDate
                      ? Moment(dates[0].endDate).format("DD-MM-YYYY") ||
                        "Ending date"
                      : "Ending date"
                    : "Ending date"}
                </span>
                <svg width="18" height="10" viewBox="0 0 18 10" fill="none">
                  <path
                    d="M0.255101 0.255101C0.564313 -0.0541122 1.04818 -0.0822225 1.38915 0.17077L1.48683 0.255101L9 7.76787L16.5132 0.255101C16.8224 -0.0541122 17.3062 -0.0822225 17.6472 0.17077L17.7449 0.255101C18.0541 0.564313 18.0822 1.04818 17.8292 1.38915L17.7449 1.48683L9.61587 9.61587C9.30665 9.92508 8.82279 9.95319 8.48182 9.7002L8.38413 9.61587L0.255101 1.48683C-0.0850335 1.1467 -0.0850335 0.595235 0.255101 0.255101Z"
                    fill="#1A4D6D"
                  />
                </svg>
              </div>
            </div>
            <div className="mt-2 d-md-flex align-items-center justify-content-center text-center">
              <div className="bg-white rounded-3 text-center">
                <DateRangePicker
                  ranges={dates}
                  onChange={(item) => {
                    setDates([item.selection]);
                    setDateSelected(true);
                  }}
                  moveRangeOnFirstSelection={true}
                  minDate={new Date()}
                  selectsStart={true}
                  startDate={dates[0].startDate}
                  endDate={dates[0].endDate}
                  inline={true}
                />
                <button className="dark-btn mt-1 mb-2 mx-auto">{getDaysLength()}{" "}{getDaysLength() > 1 ? "Days" : "Day"}</button>
              </div>
              <button
                onClick={() =>
                  setDates([
                    {
                      startDate: new Date(),
                      endDate: new Date(),
                      key: "selection",
                      selected: false,
                    },
                  ])
                }
                className="my-3 light-btn d-md-inline d-block mx-md-2 mx-auto px-2 bg-danger"
              >
                Reset Dates
              </button>
            </div>
            {/* next prev btns */}
            <div className="row justify-content-between my-3">
              <div className="col-md-5 col-6">
                <button
                  className="light-btn w-100 text-white"
                  onClick={() => setActiveStep(1)}
                >
                  Previous
                </button>
              </div>
              <div className="col-md-5 col-6">
                <button
                  onClick={() => setActiveStep(3)}
                  className="light-btn w-100 text-white"
                >
                  Next
                </button>
              </div>
            </div>
            {/*  */}
            <div className="cs-timeline">
              {[...Array(steps)].map((step, i) => {
                return (
                  <div
                    key={i}
                    className={`${
                      activeStep >= i ? "bg-sec text-white" : "bg-white"
                    }  create_yacht_cs_step cs-step`}
                  >
                    {i + 1}
                  </div>
                );
              })}
            </div>
          </div>
        </Fade>
      </div>
      {/*  */}
      <Socials />
    </section>
  );
};

const Step2 = ({
  formData,
  setFormData,
  errors,
  setBoatTypeModal,
  boatTypeModal,
  setErrors,
  steps,
  activeStep,
  setActiveStep,
}) => {
  // boats list
  let boats = [
    { name: "Motor Yachts", id: 0 },
    { name: "Catamarans", id: 1 },
    { name: "Sailiing Yachts", id: 2 },
    // { name: "Bowrider Boats", id: 3 },
    { name: "Floating Ribs", id: 3 },
  ];
  return (
    <section className="createYacht_sec step_3">
      <div className="createYacht_container">
        <Fade cascade>
          <div className="create_yacht_modal">
            <h2 className="text-center">
              Make your own yachting trip <br /> in 4 Steps.
            </h2>
            <p className="my-3 fw-light text-center">
              Let us know what kind of yacht would you prefer
            </p>
            <div className="">
              <p className="fw-light text-left pb-2">Choose your boat type</p>
              <div className="all-offer-page-top-form mb-1">
                <ClickAwayListener onClickAway={() => setBoatTypeModal(false)}>
                  <div className="col-md-11 col-12 p-0">
                    <div className="left-side-choose-city  d-flex align-items-center justify-content-start">
                      <span className="text-sec">
                        {/*  */}
                        <span className="d-md-inline d-none">&nbsp;</span>
                        <svg
                          width="27"
                          height="24"
                          viewBox="0 0 27 24"
                          fill="none"
                        >
                          <path
                            d="M25.9394 18.4946L21.9647 23.021C21.7898 23.2201 21.545 23.3333 21.2884 23.3333H3.27959C2.94304 23.3333 2.6331 23.1392 2.47043 22.8266L0.115044 18.3003C-0.0429436 17.9966 -0.0378909 17.627 0.12823 17.3282C0.294597 17.0296 0.597262 16.8462 0.924204 16.8462H25.2631C25.631 16.8462 25.9638 17.0775 26.1106 17.4353C26.2574 17.7931 26.1902 18.2092 25.9394 18.4946ZM24.8172 13.4414L11.6334 0.266742C11.3649 -0.00146079 10.9719 -0.0746546 10.6333 0.0802287C10.2946 0.235373 10.0754 0.589056 10.0754 0.980251V14.155C10.0754 14.6964 10.4891 15.1353 10.9996 15.1353H24.1833C24.5621 15.1353 24.9026 14.8901 25.0424 14.5167C25.1823 14.1431 25.0929 13.7169 24.8172 13.4414ZM7.79061 7.83825C7.45196 7.68324 7.05884 7.75656 6.79043 8.02476L1.37031 13.4414C1.09464 13.7169 1.00529 14.143 1.14516 14.5164C1.28491 14.8898 1.62529 15.135 2.00423 15.135H7.42435C7.93491 15.135 8.34861 14.6961 8.34861 14.1547V8.73827C8.34849 8.34708 8.12926 7.99339 7.79061 7.83825Z"
                            fill="#3F8BBF"
                          />
                        </svg>
                      </span>
                      <div
                        onClick={() => setBoatTypeModal(!boatTypeModal)}
                        className={`select_departure_location d-flex justify-content-start align-items-center ${
                          boatTypeModal ? "openedLocationModal" : ""
                        }`}
                      >
                        <span>
                          {formData?.boatType?.length > 0
                            ? formData?.boatType
                            : "Boat Type"}
                        </span>
                        <svg
                          width="15"
                          height="8"
                          viewBox="0 0 15 8"
                          fill="none"
                        >
                          <path
                            d="M0.612998 0.206748C0.863602 -0.0438557 1.25576 -0.0666378 1.5321 0.138402L1.61127 0.206748L7.70037 6.29553L13.7895 0.206748C14.0401 -0.0438557 14.4322 -0.0666378 14.7086 0.138402L14.7877 0.206748C15.0383 0.457352 15.0611 0.849506 14.8561 1.12585L14.7877 1.20502L8.1995 7.79325C7.9489 8.04386 7.55674 8.06664 7.2804 7.8616L7.20123 7.79325L0.612998 1.20502C0.337334 0.929352 0.337334 0.482412 0.612998 0.206748Z"
                            fill="#1A4D6D"
                          />
                        </svg>
                      </div>
                      <div
                        className={`select_departure_location_modal ${
                          boatTypeModal ? "openedLocationModal" : ""
                        }`}
                      >
                        <h5>Types</h5>
                        {boats?.map((v, i) => (
                          <p
                            key={i}
                            className=""
                            onClick={() => {
                              setFormData({
                                ...formData,
                                boatType: boats[v?.id]?.name,
                              });
                              // setErrors({
                              //   boatType: { invalid: false, msg: "" },
                              // });
                              setBoatTypeModal(false);
                            }}
                          >
                            {v?.name}
                          </p>
                        ))}
                      </div>
                    </div>
                  </div>
                </ClickAwayListener>
              </div>
              <p className="fw-light text-left my-3">
                Choose if you would like a skipper for your trip
              </p>
              {/* /  */}
              <div className="create_yacht_skipper_choose mt-2 d-flex justify-content-start align-items-center">
                <span
                  className={`${formData?.skipper ? "" : " selected_skipper"}`}
                  onClick={() => setFormData({ ...formData, skipper: false })}
                >
                  No
                </span>
                <svg width="49" height="50" viewBox="0 0 49 50" fill="none">
                  <path
                    opacity="0.2"
                    d="M9.44102 42.8131C9.09357 43.2382 9.15536 43.8663 9.59449 44.1959C13.0008 46.7521 17.0314 48.3598 21.2745 48.8447C25.8473 49.3674 30.474 48.5642 34.603 46.5308C38.7321 44.4974 42.1894 41.3196 44.5628 37.3762C46.9363 33.4328 48.1257 28.89 47.9895 24.2895C47.8532 19.6889 46.397 15.2245 43.7943 11.4285C41.1916 7.63246 37.5523 4.66486 33.3102 2.87941C29.068 1.09395 24.4019 0.56596 19.8681 1.35836C15.6611 2.09363 11.7327 3.93696 8.48364 6.69036C8.06479 7.04532 8.04028 7.67598 8.41228 8.07977C8.78428 8.48357 9.41181 8.50743 9.83198 8.15404C12.7996 5.65815 16.379 3.9865 20.2104 3.31689C24.3686 2.59013 28.6482 3.07438 32.5389 4.71193C36.4296 6.34947 39.7674 9.07123 42.1545 12.5528C44.5416 16.0344 45.8772 20.1289 46.0021 24.3483C46.1271 28.5678 45.0362 32.7342 42.8594 36.3509C40.6825 39.9677 37.5117 42.8822 33.7247 44.7471C29.9377 46.6121 25.6943 47.3488 21.5003 46.8694C17.6361 46.4277 13.9639 44.9708 10.8538 42.655C10.4135 42.3271 9.78846 42.388 9.44102 42.8131Z"
                    fill="#92B9D5"
                    stroke="white"
                    strokeOpacity="0.9"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M37.8177 24.2496C37.8177 21.7591 36.3021 19.184 33.6594 17.1846C30.945 15.131 27.4823 14 23.9089 14C20.3355 14 16.8727 15.131 14.1583 17.1846C11.5157 19.184 10 21.7591 10 24.2496V24.587L11.5805 26.104H36.3392L37.8177 24.5798V24.2496ZM23.9597 24.2731C22.1805 24.2731 20.7331 22.8256 20.7331 21.0465H22.3622C22.3622 21.63 22.6768 22.1412 23.1451 22.42V19.6482H22.0218V18.019H23.1451V16.6873H24.7743V18.019H25.8976V19.6482H24.7743V22.42C25.2426 22.1412 25.5572 21.63 25.5572 21.0465H27.1863C27.1863 22.8256 25.7389 24.2731 23.9597 24.2731Z"
                    fill="white"
                  />
                  <path
                    d="M12.6686 27.7332H35.2285V29.4467H12.6686V27.7332Z"
                    fill="white"
                  />
                  <path
                    d="M12.6686 31.0759V31.1142L12.6903 32.0945C12.6903 34.2481 14.4408 36.0001 16.5926 36.0001H31.326C33.4778 36.0001 35.2284 34.248 35.2284 32.0945V31.0759H12.6686Z"
                    fill="white"
                  />
                </svg>
                <span
                  className={`${formData?.skipper ? "selected_skipper" : " "}`}
                  onClick={() => setFormData({ ...formData, skipper: true })}
                >
                  Yes
                </span>
              </div>
              {/* next/prev btns */}
              <div className="row justify-content-between my-3">
                <div className="col-md-5 col-6">
                  <button
                    className="light-btn w-100 text-white"
                    onClick={() => setActiveStep(0)}
                  >
                    Previous
                  </button>
                </div>
                <div className="ccol-md-5 col-6">
                  <button
                    onClick={() => setActiveStep(2)}
                    className="light-btn w-100 text-white"
                  >
                    Next
                  </button>
                </div>
              </div>
              {/* */}
              <div className="cs-timeline">
                {[...Array(steps)].map((step, i) => {
                  return (
                    <div
                      key={i}
                      className={`${
                        activeStep >= i ? "bg-sec text-white" : "bg-white"
                      } cursor-auto cs-step create_yacht_cs_step`}
                    >
                      {i + 1}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Fade>
      </div>
      {/*  */}
      <Socials />
    </section>
  );
};

// const Step4 = ({
//   formData,
//   setFormData,
//   errors,
//   setBoatTypeModal,
//   boatTypeModal,
//   setErrors,
//   steps,
//   activeStep,
//   setActiveStep,
//   featuresList,
//   setFeaturesList
// }) => {
//   const featuresDataList = [
//     {
//       title: "WIFI",
//       name: "wifi",
//       img: icon1,
//     },
//     { title: "Fishing Equipment", name: "fishing_equipment", img: icon2 },
//     { title: "Events Allowed", name: "events_allowed", img: icon3 },
//     { title: "Music System", name: "music_system", img: icon4 },
//     { title: "Open Bar", name: "open_bar", img: icon5 },
//     { title: "BBQ Catering", name: "bbq_catering", img: icon6 },
//     { title: "Events Allowed", name: "events_allowed1", img: icon7 },
//     { title: "Watersports", name: "watersports", img: icon8 },
//     { title: "Pets allowed", name: "pets_allowed", img: icon9 },
//   ];
//   return (
//     <>
//       <section className="last_step_create_yacht">
//         <div className="cs_container">
//           <h2 className="text-pr mt-2 text-center">
//             Customize your yacht voyage.
//           </h2>
//           <p className="text-sec mb-3 text-center">
//             Experience bespoke yacht voyages across Greece in 4 steps
//           </p>
//           <div className="cs-timeline">
//             {[...Array(steps)].map((step, i) => {
//               return (
//                 <div
//                   key={i}
//                   className={`${
//                     activeStep === i ? "bg-sec text-white" : "bg-white"
//                   } cursor-auto cs-step create_yacht_cs_step`}
//                 >
//                   {i + 1}
//                 </div>
//               );
//             })}
//           </div>
//           <h5 className="text-sec my-4 text-center">
//             Choose your features/amenities
//           </h5>
//           <div className="col-md-12 mx-auto">
//             <div className="create_yacht_select_extras row mx-auto p-md-5 p-0 justify-content-center">
//               {featuresDataList.map((feature, ind) => (
//                 <div key={ind} className={`col-md-4 col-6 my-md-3 my-2 p-md-3 p-2`}>
//                   <label htmlFor={feature.name} className="checkbox-button ">
//                     <img className="" src={feature?.img} alt="" />
//                     <input
//                       checked={featuresList?.[feature.name]}
//                       onChange={(e) => {
//                         setFeaturesList({
//                           ...featuresList,
//                           [feature.name]: e.target.checked,
//                         });
//                       }}
//                       type="checkbox"
//                       className="checkbox-button__input"
//                       id={feature.name}
//                       name={feature.name}
//                     />
//                     <span className="checkbox-button__control"></span>
//                     <span
//                       className={`checkbox-button__label ad-list-chkboxlablel ${
//                         feature.input
//                           ? featuresList?.[feature.name]
//                             ? "text-pr"
//                             : "text-gr"
//                           : "text-pr"
//                       }`}
//                     >
//                       {feature.title}
//                     </span>
//                   </label>
//                 </div>
//               ))}
//             </div>
//           </div>
//           <div className="col-8 mx-auto my-md-5 my-3 pb-md-5 pb-3">
//             <div className="step-bottom-btns-wraps">
//               <Link to="/" className="step-next-prev-btn cancel-stp-btn">
//                 Cancel
//               </Link>
//               <button
//                 onClick={() => setActiveStep(2)}
//                 className={`step-next-prev-btn prev-stp-btn`}
//               >
//                 Previous
//               </button>
//               <div className="add-listing-next-preview-btn-box">
//                 <Link to="/listing" className={`text-white step-next-prev-btn next-stp-btn`}>
//                   Search available
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* <div className="createYacht_container">
//         <Fade cascade>
//           <div className="create_yacht_modal">
//             <h2>Final Step Submit your yacht!</h2>
//             <p className="my-3 fw-light text-center">
//               Thank you for choosing CYAN.
//             </p>
//             <br />
//             <br />
//             <br />
//             <br />
//             <div className="">
//               <div className="row justify-content-between my-3">
//                 <div className="col-md-5 col-6">
//                   <button
//                     className="light-btn w-100 text-white"
//                     onClick={() => setActiveStep(2)}
//                   >
//                     Previous
//                   </button>
//                 </div>
//                 <div className="col-md-5 col-6">
//                   <button
//                     className="light-btn w-100 text-white"
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </div>
//               <div className="cs-timeline">
//                 {[...Array(steps)].map((step, i) => {
//                   return (
//                     <div
//                       key={i}
//                       className={`${
//                         activeStep >= i ? "bg-sec text-white" : "bg-white"
//                       } cursor-auto cs-step create_yacht_cs_step`}
//                     >
//                       {i + 1}
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>
//         </Fade>
//       </div> */}
//       </section>
//     </>
//   );
// };

const Step4 = ({
  formData,
  setFormData,
  errors,
  setBoatTypeModal,
  boatTypeModal,
  setErrors,
  steps,
  activeStep,
  setActiveStep,
  featuresList,
  setFeaturesList,
}) => {
  return (
    <Listing
      stepPage
      formData={formData}
      errors={errors}
      setErrors={setErrors}
      setBoatTypeModal={setBoatTypeModal}
      boatTypeModal={boatTypeModal}
      setFormData={setFormData}
      steps={4}
      activeStep={activeStep}
      setActiveStep={setActiveStep}
      featuresList={featuresList}
      setFeaturesList={setFeaturesList}
    />
  );
};

const Socials = () => {
  return (
    <div className="footer-socials-wraps all_offers_page_socials">
      <a
        href="https://www.facebook.com/Cyan-115485296918323"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={fbIcon} alt="" />
      </a>
      {/* <a href="/" target="_blank" rel="noopener noreferrer"><img src={twitterIcon} alt="" /></a> */}
      <a
        href="https://www.instagram.com/thecyangroup/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={instaIcon} alt="" />
      </a>
    </div>
  );
};
export default CreateYacht;
